module.exports = __webpack_public_path__ + "static/media/Icon_Logo_Grey.53ec3051.svg";